// ============================================
// THEME (Same as teacher assignment for consistency)
// ============================================

export const STUDENT_ASSIGNMENT_THEME_COLOR = '#22C55E'; // Green-500

// ============================================
// WIZARD STEPS
// ============================================

export enum StudentAssignmentStep {
  PREVIEW = 'preview',
  QUESTIONS = 'questions',
  RESULT = 'result',
  ERROR = 'error',
}

// ============================================
// SUBMISSION STATUS (matches backend)
// ============================================

export enum SubmissionStatus {
  IN_PROGRESS = 'in_progress',
  SUBMITTED = 'submitted',
  GRADED = 'graded',
  EXPIRED = 'expired',
}

// ============================================
// QUESTION TYPES (matches backend)
// ============================================

export enum QuestionType {
  MULTIPLE_CHOICE = 'multiple_choice',
  SHORT_ANSWER = 'short_answer',
  ESSAY = 'essay',
}

// ============================================
// API RESPONSE TYPES
// ============================================

export interface AssignmentPreview {
  id: string;
  teacherId?: string | null;
  subject: string;
  grade: string;
  questionCount: number;
  totalPoints: number;
  timeLimit?: number;
  dueDate?: string;
}

export interface QuestionOption {
  id: string;
  text: string;
}

export interface SubmissionQuestion {
  id: string;
  type: QuestionType;
  questionText: string;
  options: QuestionOption[];
  points: number;
  order: number;
}

export interface QuestionAnswer {
  questionId: string;
  selectedOptionId?: string;
  textAnswer?: string;
  maxPoints: number;
  pointsAwarded?: number;
  feedback?: string;
  firstViewedAt?: string;
  lastViewedAt?: string;
  firstAnsweredAt?: string;
  lastAnsweredAt?: string;
}

export interface SubmissionResponse {
  id: string;
  assignmentId: string;
  studentId: string;
  status: SubmissionStatus;
  answers: QuestionAnswer[];
  questions: SubmissionQuestion[];
  startedAt: string;
  submittedAt?: string;
  expiresAt?: string;
  totalPointsAwarded?: number;
  totalPointsPossible?: number;
  gradePercentage?: number;
  createdAt: string;
}

export interface GetSubmissionResponse {
  started: boolean;
  submission: SubmissionResponse | null;
}

export interface SubmissionResult {
  id: string;
  assignmentId: string;
  status: SubmissionStatus;
  answers: QuestionAnswer[];
  totalPointsAwarded: number;
  totalPointsPossible: number;
  gradePercentage: number;
  startedAt: string;
  submittedAt: string;
}

// ============================================
// SAVE ANSWER DTO
// ============================================

export interface SaveAnswerDto {
  selectedOptionId?: string;
  textAnswer?: string;
  viewedAt?: string;
}

// ============================================
// GRADING PROGRESS STEPS
// ============================================

export interface GradingProgressStep {
  key: string;
  label: string;
}

export const GRADING_PROGRESS_STEPS: GradingProgressStep[] = [
  { key: 'analyzing', label: 'Analyzing your answers...' },
  { key: 'grading', label: 'Grading your responses...' },
  { key: 'feedback', label: 'Generating feedback...' },
  { key: 'finalizing', label: 'Calculating final score...' },
];

// ============================================
// ERROR TYPES
// ============================================

export enum StudentAssignmentErrorType {
  NOT_FOUND = 'not_found',
  EXPIRED = 'expired',
  ALREADY_SUBMITTED = 'already_submitted',
  TEACHER_ACCESS = 'teacher_access',
  UNKNOWN = 'unknown',
}
